import { render, staticRenderFns } from "./RateAnamnese.vue?vue&type=template&id=3c35927a&scoped=true"
import script from "./RateAnamnese.vue?vue&type=script&lang=js"
export * from "./RateAnamnese.vue?vue&type=script&lang=js"
import style0 from "./RateAnamnese.vue?vue&type=style&index=0&id=3c35927a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35927a",
  null
  
)

export default component.exports